// Caminho relativo: src/environments/environment.model.ts
export enum EnvironmentName {
  development = 'development',
  homolog = 'homolog',
  production = 'production',
}

export interface OfflineStoreConfig {
  userProfile?: boolean;
  farms?: boolean;
  productList?: boolean;
  questions?: boolean;
  sections?: boolean;
  reasonList?: boolean;
  compatibility?: boolean;
  problems?: boolean;
  serviceOrders?: boolean;
  checklists?: boolean;
  visitDiaries?: boolean;
  managementPlans?: boolean;
}

export interface Environment {
  name: EnvironmentName;
  production: boolean;
  authApi: string;
  api: string;
  offlineStore?: OfflineStoreConfig;

}

export const environmentNames: string[] = Object.keys(EnvironmentName).map(
  (key) => EnvironmentName[key]
);